import { trackPaymentCompleted } from "@/events/googleAdsEvents";
import { mixpanelTrack } from "@/events/mixpanelTrack";
import { safeGetItem, safeSetItem } from "@/utils/safeStorage";
import { useEffect } from "react";
import { useLocation } from "react-router";

import SubscriberOnboarding from "../Onboarding/SubscriberOnboarding";

const sentKey = (eventId: string) => `payment_completed_${eventId}`;

const PaymentSuccess = () => {
  const search = useLocation().search;
  const urlParams = new URLSearchParams(search);
  const priceId = urlParams.get("price_id");
  const eventId = urlParams.get("event_id");

  const action = `page_success_${priceId}`;

  useEffect(() => {
    if (eventId && priceId) {
      mixpanelTrack("subscription_conversion");
    }
  }, [action, eventId, priceId]);

  // Google Ads conversion, once per checkout: a reload or a revisit of this
  // URL keeps its event_id, so it is remembered here.
  useEffect(() => {
    if (!eventId || !priceId || safeGetItem(sentKey(eventId))) return;
    safeSetItem(sentKey(eventId), "1");
    trackPaymentCompleted();
  }, [eventId, priceId]);

  return <SubscriberOnboarding />;
};

export default PaymentSuccess;
